import UserListController from './user.list.controller';

export default {
    controller: UserListController,
    template: require('./user.list.tpl.html')
};
